import { EventLog } from '@adornis/analytics/db/eventlog.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';

@Entity()
export class EvaluationTerminWarningMailEventLog extends EventLog {
  public static override _class = 'EvaluationTerminWarningMailEventLog';
  constructor(doc: PartialEntityData<EvaluationTerminWarningMailEventLog>) {
    super(doc);
  }

  @Field(type => ID)
  public inspectorID!: string;
}
